import styled from 'styled-components';

export const StyledCertificate = styled.div`
    padding: 200px 0 200px;
    position: relative;
    background: #152637;
    overflow: hidden;

    &.version_two {
        background: #DD223F;
        padding: 200px 0 200px;
    }

    .subtitle-ygen {
        color: #FFFFFF80;
    }

    .fixed-right {
        position: absolute;
        right: 0;
        top: 40%;
    }

    .navigation-item {
        margin-top: 40px;
        gap: 15px;
    }

    @media (max-width: 767px) {
        padding: 120px 0;
        .mobile-justify {
            justify-content: flex-start !important;

            .navigation-item {
                gap: 15px;
                display: flex !important;
            }
        }
    }
`;